import axios from '@/axios';


const state = {
	connectionStatus: navigator.onLine,
	queue: JSON.parse(window.localStorage.getItem('italmotori_queue')) || [],
	cache: JSON.parse(window.localStorage.getItem('italmotori_cache')) || {}
};

const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

const actions = {
	changeConnectionStatus({commit,dispatch}, status) {

		if (status){
        	dispatch('alert/success', 'Sei tornato online!', { root: true });
		}else{
        	dispatch('alert/warning', 'Connessione assente. in modalità offline, le funzionalità sono limitate', { root: true });
		}
		commit('changeConnectionStatus', status);
	},
	addRequestToQueue({commit, dispatch}, request) {
        dispatch('alert/success', 'Sei in modalità offline, la richiesta verrà processata', { root: true });
		
		commit('addRequest', {
			sendedAt: new Date(),
			...request
		});
	},
	async resolveQueue({commit, dispatch, state}) {
		if (state.connectionStatus){
			
			// TODO sarebbe da fare una get di nuovo del local storage, perché solo così sei sicuro che magari queste chiamate non sono state eseguite da un altra scheda aperta.

	        dispatch('alert/success', 'Inizio sessione di ripristino chiamate. Se puoi, non toccare il dispositivo', { root: true });
	        const queue = [...state.queue]
			await asyncForEach(queue, async (req,i) => {
				// TODO inserire try catch, salvare in localStorage i req delle richieste non andate a buon fine, 
				await axios[req.method](req.url,req.data)
				commit('removeQueueItem',req)
			})
	        dispatch('alert/success', 'Sessione di ripristino chiamate completata.', { root: true });
	        setTimeout(function(){
	        	window.location.reload(true)
	        },2000)
		}else{
	        dispatch('alert/error', 'Non sei connesso, non puoi far partire la coda delle chiamate', { root: true });

		}
	},
	cacheRequest({commit, dispatch}, response) {
		commit('cacheRequest',response);
	}
}


const mutations = {
	addRequest(state, request) {
		state.queue.push(request)
		try{
			window.localStorage.setItem('italmotori_queue',JSON.stringify(state.queue));
		} catch(e) {
			
		}
	},
	cacheRequest(state, response) { 
		state.cache[response.config.url] = response
		try{
			window.localStorage.setItem('italmotori_cache',JSON.stringify(state.cache));
		} catch (e) {
			
		}
	},
	changeConnectionStatus(state,bool) {
		state.connectionStatus = bool
	},
	removeQueueItem(state, req){
		state.queue = state.queue.filter(reqToRemove => reqToRemove.hash !== req.hash)
	}
}

export const offline = {
    namespaced: true,
    state,
    actions,
    mutations
};